// removed by extract-text-webpack-plugin
module.exports = {"link":"_1luxT","footer":"trBjT","avatar":"g1o3v","avatar-container":"_3vfBH","placeholder":"_3J3Tg","action-container":"_3N_Im","action":"_1SYmk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RichUpdates/RichUpdatesCreator/RichUpdatesCreator.scss
// module id = ./src/components/RichUpdates/RichUpdatesCreator/RichUpdatesCreator.scss
// module chunks = 5